// extracted by mini-css-extract-plugin
module.exports = {"section":"H_section__EDITD","space1":"H_space1__07WXx"};